import { IPagingSettings, ISiteModel, ISortingSettings } from '@module/shared/components/Site/models';
import { requestSiteGet, requestSitePost } from '@service/siteDataService';

export const SERVIS_SITE_POST_REQUEST = 'SERVIS_SITE_POST_REQUEST';
export const SERVIS_SITE_POST_SUCCESS = 'SERVIS_SITE_POST_SUCCESS';
export const SERVIS_SITE_POST_ERROR = 'SERVIS_SITE_POST_ERROR';
export const SERVIS_SITE_GET_REQUEST = 'SERVIS_SITE_GET_REQUEST';
export const SERVIS_SITE_GET_SUCCESS = 'SERVIS_SITE_GET_SUCCESS';
export const SERVIS_SITE_GET_ERROR = 'SERVIS_SITE_GET_ERROR';
export const SERVIS_SITE_PAGING_CHANGE = 'SERVIS_SITE_PAGING_CHANGE';
export const SERVIS_SITE_SORT_CHANGE = 'SERVIS_SITE_SORT_CHANGE';
export const SITE_APPLY_SEARCH = 'SITE_APPLY_SEARCH';
export const SITE_SEARCH_CHANGE = 'SITE_SEARCH_CHANGE';
export const REGISTERED_NEW_SITE_SELECTED = 'REGISTERED_NEW_SITE_SELECTED';
export const SERVIS_SITE_REGISTER_ERROR = 'SERVIS_SITE_REGISTER_ERROR';
export const SERVIS_SITE_REGISTER_SUCCESS = 'SERVIS_SITE_REGISTER_SUCCESS';
export const SERVIS_SITE_PAGE_LEAVE = 'SERVIS_SITE_PAGE_LEAVE';

export function onSiteGetRequest(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onSiteResponseSuccess(response: any) {
    return {
        type: SERVIS_SITE_GET_SUCCESS,
        sites: response.sites,
        totalNumberOfSites: response.totalCount
    };
}

export function onSiteResponseError() {
    return {
        type: SERVIS_SITE_GET_ERROR,
        text: 'Error receiving data'
    };
}

export async function makeSiteGetRequest(dispatch: any, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    dispatch({ type: SERVIS_SITE_GET_REQUEST });
    try {
        const sites = await requestSiteGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
        dispatch(onSiteResponseSuccess(sites));
    } catch (error) {
        console.error('ServIS site get request failed', error);
        dispatch(onSiteResponseError());
    }
}

export function onPagingChange(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        dispatch({ type: SERVIS_SITE_PAGING_CHANGE, pagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onSortingChange(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        const newPagingSettings = { ...pagingSettings, skipItems: 0 };
        dispatch({ type: SERVIS_SITE_SORT_CHANGE, pagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onFilterFieldChange(searchFilter: string) {
    return {
        type: SITE_SEARCH_CHANGE,
        searchFilter
    };
}

export function onFilterApplied(searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        const newPagingSettings = { ...pagingSettings, skipItems: 0 };
        dispatch({ type: SITE_APPLY_SEARCH, searchFilter });
        dispatch({ type: SERVIS_SITE_PAGING_CHANGE, pagingSettings: newPagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onSiteSelected(siteIsSelected: boolean, selectedSite: ISiteModel) {
    return {
        type: REGISTERED_NEW_SITE_SELECTED,
        siteSelected: siteIsSelected,
        selectedSite
    };
}

export function onRegisterSite(selectedSite: ISiteModel, accessToken: string) {
    return (dispatch: any) => {
        makeSitePostRequest(dispatch, selectedSite, accessToken);
    };
}

export function makeSitePostRequest(dispatch: any, site: ISiteModel, accessToken: string) {
    return requestSitePost(site, accessToken).then(
        (success: ISiteModel) =>
            dispatch(onRegisterSiteResponseSuccess(success)),
        error =>
            dispatch(onRegisterSiteResponseError())
    );
}

export function onRegisterSiteResponseSuccess(site: ISiteModel) {
    return {
        type: SERVIS_SITE_REGISTER_SUCCESS,
        site
    };
}

export function onRegisterSiteResponseError() {
    return {
        type: SERVIS_SITE_REGISTER_ERROR,
        text: 'Error receiving data'
    };
}

export function onRegisterPageLeave() {
    return {
        type: SERVIS_SITE_PAGE_LEAVE
    };
}
